module.exports = __webpack_public_path__ + "static/media/Volibear.f3465f54.png";